import { Component } from '@angular/core';
import { CommonService } from '../../Model/Common/common.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { UtilityService } from '../../Model/utility/utility.service';

@Component({
  selector: 'app-pre-onboardin-main-layou',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule, NgbCollapseModule, RouterOutlet, RouterModule],
  templateUrl: './pre-onboardin-main-layou.component.html',
  styleUrl: './pre-onboardin-main-layou.component.scss'
})
export class PreOnboardinMainLayouComponent {
  user: any;
  constructor(
    private session: SessionService,
    private common: CommonService,
    private toast: ToastService,
    private tooltip: TooltipService,
    private utility: UtilityService,
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit(): void {
    // if (this.user.IsPreOnBoarding) {
    //   this.common.ComboLoad('document');
    // } else {
    //   this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    //   this.Logout();
    // }
    if (!this.user.IsPreOnBoarding) {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      this.Logout();
    }
  }

  Logout() {
    this.utility.LogOutDetails({ 'SelectType': 'LogOut', LoginName: this.user.LoginName }).subscribe({
      next: (response) => {
        if (response.Error_Code == "09")
          this.session.End();
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  IsMobile(){
    if(window.innerWidth < 768){
      return true;
    }else{
      return false;
    }
  }
}
